// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

.mode-tools_mode-tools_zqH51 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  min-height: 3rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

.mode-tools_mode-tools-icon_q0Gzh {
  margin-right: calc(2 * 0.25rem);
  width: 2rem;
  height: 2rem;
  -webkit-filter: var(--paint-filter-icon-gray, none);
          filter: var(--paint-filter-icon-gray, none);
}

[dir='ltr'] .mode-tools_mod-dashed-border_sSLWw {
  border-right: 1px dashed var(--paint-ui-pane-border, #d9d9d9);
  padding-right: calc(3 * 0.25rem);
}

[dir='rtl'] .mode-tools_mod-dashed-border_sSLWw {
  border-left: 1px dashed var(--paint-ui-pane-border, #d9d9d9);
  padding-left: calc(3 * 0.25rem);
}

.mode-tools_mod-labeled-icon-height_idcoM {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 2.85rem; /* for the second row so the dashed borders are equal in size */
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

.mode-tools_mod-unselect_CNDxE {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.mode-tools_mod-context-menu_ziC82 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
      -ms-flex-direction: column;
          flex-direction: column;
}

.mode-tools_mod-menu-item_txaOB {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0 -0.25rem;
  min-width: 6.25rem;
  padding: calc(3 * 0.25rem);
  white-space: nowrap;
  cursor: pointer;
  -webkit-transition: 0.1s ease;
  transition: 0.1s ease;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
}

.mode-tools_mod-disabled_AUONK {
  cursor: auto;
}

.mode-tools_mod-menu-item_txaOB:hover {
  background: var(
  --paint-looks-transparent,
  hsla(260, 60%, 60%, 0.35)
);
}

.mode-tools_mod-disabled_AUONK:hover {
  background-color: transparent;
}

.mode-tools_menu-item-icon_rEC7K {
  margin-right: calc(2 * 0.25rem);
  width: 1.25rem;
  height: 1.25rem;
}

[dir='rtl'] .mode-tools_menu-item-icon_rEC7K {
  margin-right: 0;
  margin-left: calc(2 * 0.25rem);
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/mode-tools/mode-tools.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,mDAAmD;UAC3C,2CAA2C;AACrD;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,4DAA4D;EAC5D,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,eAAe,EAAE,+DAA+D;EAChF,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;AAC7B;;AAEA;EACE,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;MAC1B,0BAA0B;UACtB,sBAAsB;AAChC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;EAC3B,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;;CAGD;AACD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n.mode-tools {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 3rem;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.mode-tools-icon {\n  margin-right: calc(2 * 0.25rem);\n  width: 2rem;\n  height: 2rem;\n  -webkit-filter: var(--paint-filter-icon-gray, none);\n          filter: var(--paint-filter-icon-gray, none);\n}\n\n[dir='ltr'] .mod-dashed-border {\n  border-right: 1px dashed var(--paint-ui-pane-border, #d9d9d9);\n  padding-right: calc(3 * 0.25rem);\n}\n\n[dir='rtl'] .mod-dashed-border {\n  border-left: 1px dashed var(--paint-ui-pane-border, #d9d9d9);\n  padding-left: calc(3 * 0.25rem);\n}\n\n.mod-labeled-icon-height {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 2.85rem; /* for the second row so the dashed borders are equal in size */\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.mod-unselect {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.mod-context-menu {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.mod-menu-item {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 -0.25rem;\n  min-width: 6.25rem;\n  padding: calc(3 * 0.25rem);\n  white-space: nowrap;\n  cursor: pointer;\n  -webkit-transition: 0.1s ease;\n  transition: 0.1s ease;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-family: 'Helvetica Neue', Helvetica, sans-serif;\n}\n\n.mod-disabled {\n  cursor: auto;\n}\n\n.mod-menu-item:hover {\n  background: var(\n  --paint-looks-transparent,\n  hsla(260, 60%, 60%, 0.35)\n);\n}\n\n.mod-disabled:hover {\n  background-color: transparent;\n}\n\n.menu-item-icon {\n  margin-right: calc(2 * 0.25rem);\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n[dir='rtl'] .menu-item-icon {\n  margin-right: 0;\n  margin-left: calc(2 * 0.25rem);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mode-tools": `mode-tools_mode-tools_zqH51`,
	"modeTools": `mode-tools_mode-tools_zqH51`,
	"mode-tools-icon": `mode-tools_mode-tools-icon_q0Gzh`,
	"modeToolsIcon": `mode-tools_mode-tools-icon_q0Gzh`,
	"mod-dashed-border": `mode-tools_mod-dashed-border_sSLWw`,
	"modDashedBorder": `mode-tools_mod-dashed-border_sSLWw`,
	"mod-labeled-icon-height": `mode-tools_mod-labeled-icon-height_idcoM`,
	"modLabeledIconHeight": `mode-tools_mod-labeled-icon-height_idcoM`,
	"mod-unselect": `mode-tools_mod-unselect_CNDxE`,
	"modUnselect": `mode-tools_mod-unselect_CNDxE`,
	"mod-context-menu": `mode-tools_mod-context-menu_ziC82`,
	"modContextMenu": `mode-tools_mod-context-menu_ziC82`,
	"mod-menu-item": `mode-tools_mod-menu-item_txaOB`,
	"modMenuItem": `mode-tools_mod-menu-item_txaOB`,
	"mod-disabled": `mode-tools_mod-disabled_AUONK`,
	"modDisabled": `mode-tools_mod-disabled_AUONK`,
	"menu-item-icon": `mode-tools_menu-item-icon_rEC7K`,
	"menuItemIcon": `mode-tools_menu-item-icon_rEC7K`
};
export default ___CSS_LOADER_EXPORT___;
